export default __webpack_public_path__ + "static/media/token.6b520111.webp";